import { render, staticRenderFns } from "./RegisterWeightModal.vue?vue&type=template&id=b17db474&scoped=true&"
import script from "./RegisterWeightModal.vue?vue&type=script&lang=js&"
export * from "./RegisterWeightModal.vue?vue&type=script&lang=js&"
import style0 from "./RegisterWeightModal.vue?vue&type=style&index=0&id=b17db474&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17db474",
  null
  
)

export default component.exports